import { twMerge } from 'tailwind-merge'

export const classNames = (...classes: Array<string | boolean | null | undefined>) =>
  twMerge(classes.filter(Boolean).join(' '))

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}

export const cleanText = (textStr: string) => textStr.replace(/\n/, '').trim()

export * from './format'
